import axios from 'axios';
import settings from '../config';
import { getApplicationDataAsync } from '../services/application-service';
import { generateAuthorizationToken } from '../services/utils';

const HEADER_CONTENT = 'Content-Type';
const TYPE_JSON = 'application/json; charset=utf-8';

const API = () => {
    const api = axios.create({
        baseURL: settings.api.url
    });

    api.interceptors.request.use(async (config) => {
        const headerConfig = config;
        headerConfig.headers[HEADER_CONTENT] = TYPE_JSON;

        let appInfo = await getApplicationDataAsync()

        const params = new URLSearchParams(window.location.search);

        const authorization = params?.get("Authorization");
        const tenantId = params?.get("tenantId");

        if (authorization && tenantId) {
            headerConfig.headers.Authorization = authorization
            headerConfig.headers.tenantId = tenantId
        } else {
            headerConfig.headers.Authorization = generateAuthorizationToken(appInfo)
            headerConfig.headers.tenantId = appInfo.tenantId
        }

        return headerConfig;
    });

    return api;
};

export default API();
